import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  doc,
  getDoc,
  getDocs,
  collection,
  QuerySnapshot,
  QueryDocumentSnapshot,
  setDoc,
  addDoc,
  deleteDoc,
} from 'firebase/firestore';
import { db } from '..';
import assignTypes from '../services/converter';
import { Link, useNavigate } from 'react-router-dom';
import { JokeDocument } from '../applicationTypes';
import Modal from 'react-modal';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';

export default function Home() {
  let navigate = useNavigate();

  const query = collection(db, 'JokesCollection').withConverter(
    assignTypes<JokeDocument>()
  );

  const [jokesTypes, setJokesTypes] = useState<
    QueryDocumentSnapshot<JokeDocument>[]
  >([]);
  const getData = async () => {
    const querySnapshot = await getDocs(query);
    setJokesTypes(querySnapshot.docs);
  };
  const addJokeType = async (e: any) => {
    e.preventDefault();

    try {
      const data: JokeDocument = {
        type: e.target[0].value,
        numberOfJokes: 0,
      };

      let res = await addDoc(query, data);
      await getData();
    } catch (error) {
      console.log(error);
    }
  };

  const deleteJoke = async (id: string) => {
    let x = doc(query, id);
    await deleteDoc(x);
    await getData();
  };
  useEffect(() => {
    getData();
  }, []);

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [selectedTypeToEdit, setSelectedTypeToEdit] =
    useState<QueryDocumentSnapshot<JokeDocument> | null>(null);
  // Function to handle image selection
  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    setSelectedImage(file || null);
  };

  const editImageUrl = async () => {
    try {
      if (selectedTypeToEdit && selectedImage) {
        const storage = getStorage();

        const typeRef = ref(
          storage,
          `typeImages/${selectedTypeToEdit.id}/${selectedTypeToEdit.id}`
        );
        await uploadBytes(typeRef, selectedImage);

        let imgUrl = await getDownloadURL(typeRef);

        await setDoc(selectedTypeToEdit?.ref, {
          numberOfJokes: selectedTypeToEdit.data().numberOfJokes,
          type: selectedTypeToEdit.data().type,
          image: imgUrl,
        });
        setShowEditModal(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <div className='h3 mt-2'>قائمة النكت</div>

      <div className='d-flex flex-wrap container-sm'>
        {jokesTypes.map((joke) => {
          return (
            <div
              key={joke.id}
              className='m-2 border p-6 w-40 justify-content-center d-inline-flex flex-column'
            >
              <button
                onClick={() => {
                  navigate(`/jokeType/${joke.id}`);
                }}
                className='mb-3'
              >
                <h1>{joke.data().type}</h1>
              </button>
              <div className='d-flex flex-col  align-items-center mb-4 border'>
                <div>
                  {joke.data().image && (
                    <img
                      src={joke.data().image}
                      alt='Selected'
                      style={{ height: 100, width: 100 }}
                    />
                  )}
                </div>
              </div>
              <button
                onClick={() => deleteJoke(joke.id)}
                className='btn btn-danger mb-2'
              >
                delete
              </button>
              <button
                onClick={() => {
                  setShowEditModal(true);
                  setSelectedTypeToEdit(joke);
                }}
                className='btn btn-warning'
              >
                edit
              </button>
            </div>
          );
        })}
      </div>

      <form
        onSubmit={addJokeType}
        className=' d-inline-flex  justify-content-center flex-column'
      >
        <div className='row g-3 align-items-center mt-4 mb-2'>
          <div className='col-auto'>
            <label htmlFor='type' className='col-form-label'>
              النوع
            </label>
          </div>
          <div className='col-auto'>
            <input
              type='type'
              id='inputPassword6'
              className='form-control'
              aria-describedby='passwordHelpInline'
            />
          </div>
        </div>

        <button type='submit' className='btn btn-primary active'>
          أضف نوع جديد
        </button>
      </form>

      <Modal
        isOpen={showEditModal}
        onRequestClose={() => setShowEditModal(false)}
        contentLabel='Example Modal'
      >
        <div className='d-flex flex-col  align-items-center mt-10 border'>
          <div>
            <input type='file' accept='image/*' onChange={handleImageChange} />
            {selectedImage && (
              <img
                src={URL.createObjectURL(selectedImage)}
                alt='Selected'
                style={{ height: 100, width: 100 }}
              />
            )}
          </div>
        </div>

        <button
          type='button'
          className='align-items-center'
          data-bs-dismiss='offcanvas'
          aria-label='Close'
          onClick={editImageUrl}
        >
          edit
        </button>
      </Modal>
    </div>
  );
}
